/**
 * Giving Gap (lapsed-donor) adapter.
 *
 * The pure aggregation (period windowing, void exclusion, NaN/rounding guards,
 * lapsed-donor filter, totals) lives in @glorify-llc/accounting-core and is
 * shared with Relay (ADR-006). This file keeps the Forge-specific seam: it
 * injects the metric-registry summary labels.
 *
 * Consumers keep importing from "@/lib/reports/adapters/giving-gap-report".
 */
import { buildReportSummaryItem } from "@/lib/metrics/metric-registry";
import { type ReportAggregation } from "@glorify-llc/accounting-core";
import {
  aggregateGivingGapReport,
  type GivingGapReportContext,
} from "@glorify-llc/accounting-core";

export type {
  GivingGapReportContext,
  GapContribution,
} from "@glorify-llc/accounting-core";

export function buildGivingGapReportAggregation(
  context: GivingGapReportContext,
): ReportAggregation {
  const { rows, lapsedDonorCount, totalGapAmount } =
    aggregateGivingGapReport(context);

  return {
    asOf: context.asOf,
    summary: [
      buildReportSummaryItem("report.giving_gap.lapsed_donor_count", lapsedDonorCount),
      buildReportSummaryItem("report.giving_gap.total_gap_amount", totalGapAmount),
    ],
    rows,
  };
}
